import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // ProtectedRoute check

  if (isLoading) {
    // ProtectedRoute: Loading
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // ProtectedRoute: Not authenticated, redirecting to login
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // ProtectedRoute: Authenticated, rendering children
  return <>{children}</>
}

export default ProtectedRoute
